import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { applyConsent, getConsent, onConsentChange, onConsentOpen, setConsent } from '../lib/consent';
import './ConsentBanner.css';

// Litet kort längst ner utan overlay eller fokusfälla – sidan går att använda
// som vanligt medan bannern visas.
export default function ConsentBanner() {
  // null = dold; reopened = öppnad via Cookie-inställningar i sidfoten
  const [shown, setShown] = useState(null);
  const regionRef = useRef(null);
  const openerRef = useRef(null);

  useEffect(() => {
    if (window.__PRERENDER__) return undefined;

    applyConsent();
    // Efter första målningen, så bannern aldrig konkurrerar med sidans innehåll
    const frame = requestAnimationFrame(() => {
      if (!getConsent()) {
        setShown((prev) => prev || { current: null, reopened: false });
      }
    });
    const unsubscribeOpen = onConsentOpen(() => {
      openerRef.current = document.activeElement;
      setShown({ current: getConsent(), reopened: true });
    });
    // Valet gjordes eller rensades i en annan flik
    const unsubscribeChange = onConsentChange((consent) => {
      setShown(consent ? null : { current: null, reopened: false });
    });

    return () => {
      cancelAnimationFrame(frame);
      unsubscribeOpen();
      unsubscribeChange();
    };
  }, []);

  useEffect(() => {
    if (shown?.reopened) regionRef.current?.focus();
  }, [shown]);

  if (!shown) return null;

  const choose = (ads) => {
    setConsent({ ads });
    setShown(null);
    const opener = openerRef.current;
    openerRef.current = null;
    if (opener?.isConnected && opener !== document.body) opener.focus();
  };

  return (
    <div
      ref={regionRef}
      className="consent-banner"
      role="region"
      aria-label="Cookie-inställningar"
      tabIndex={-1}
    >
      <p className="consent-banner-text">
        Vi vill använda cookies från Google för att mäta våra annonser. Vår besöksstatistik fungerar utan cookies.{' '}
        <Link to="/cookies">Läs mer</Link>
      </p>
      {shown.current && (
        <p className="consent-banner-status">
          Nuvarande val: {shown.current.ads ? 'godkänt' : 'avvisat'}.
        </p>
      )}
      <div className="consent-banner-actions">
        <button type="button" className="consent-banner-button" onClick={() => choose(false)}>
          Avvisa
        </button>
        <button type="button" className="consent-banner-button" onClick={() => choose(true)}>
          Godkänn
        </button>
      </div>
    </div>
  );
}
